import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useTranslation } from 'react-i18next';
import { RefreshCw, CheckCircle } from 'lucide-react';
import { calendarService } from '@/services/api/calendar.service';
import { useToast } from '@/hooks/use-toast';
import { Card, CardContent } from '@/components/ui/card';

export default function CalendarCallbackPage() {
  const [, setLocation] = useLocation();
  const { t } = useTranslation('calendar');
  const { toast } = useToast();

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');

      if (!code || !state) {
        toast({
          title: t('toast.connectError'),
          description: t('toasts.invalidCallback'),
          variant: 'destructive',
        });
        setLocation('/staff/calendar-settings');
        return;
      }

      const result = await calendarService.handleCallback(code, state);

      toast({
        title: t('toast.connectSuccess'),
        description: t('toasts.connectedDescription', {
          calendar: result.connection.calendarName,
          count: result.syncedEvents,
        }),
      });

      // If opened in popup, close it. Otherwise redirect.
      if (window.opener) {
        window.close();
      } else {
        setLocation('/staff/calendar-settings');
      }
    } catch (error: any) {
      toast({
        title: t('toast.connectError'),
        description: error.message || t('toasts.connectError'),
        variant: 'destructive',
      });

      // If opened in popup, close it. Otherwise redirect.
      if (window.opener) {
        window.close();
      } else {
        setLocation('/staff/calendar-settings');
      }
    }
  };

  return (
    <div className="container mx-auto px-4 py-8 min-h-screen flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center justify-center text-center space-y-4">
            <div className="p-4 bg-primary/10 rounded-full">
              <RefreshCw className="h-12 w-12 text-primary animate-spin" />
            </div>
            <div>
              <h2 className="text-h1 text-ink mb-2">{t('callback.connecting')}</h2>
              <p className="text-soft">Please wait while we complete the connection...</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
